// "Pairs well with" rail in the cart drawer. Waits for the drawer to open,
// then loads Shopify's related-product recommendations for the newest cart item.
if (!customElements.get('cc-cart-recs')) {
  // Survives drawer re-renders (Dawn replaces the drawer HTML on every cart change).
  const ccRecsCache = new Map();

  customElements.define(
    'cc-cart-recs',
    class CcCartRecs extends HTMLElement {
      connectedCallback() {
        this.rail = this.querySelector('.cc-recs__rail');
        this.prev = this.querySelector('[data-dir="-1"]');
        this.next = this.querySelector('[data-dir="1"]');
        this.prev.addEventListener('click', () => this.page(-1));
        this.next.addEventListener('click', () => this.page(1));
        this.rail.addEventListener('scroll', () => this.updateArrows(), { passive: true });

        this.drawer = this.closest('cart-drawer');
        if (!this.drawer || this.drawer.classList.contains('active')) {
          this.load();
          return;
        }
        this.observer = new MutationObserver(() => {
          if (!this.drawer.classList.contains('active')) return;
          this.observer.disconnect();
          this.load();
        });
        this.observer.observe(this.drawer, { attributes: true, attributeFilter: ['class'] });
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      async load() {
        const productId = this.dataset.productId;
        if (!productId) return;
        const key = `${productId}|${this.dataset.exclude}`;
        let html = ccRecsCache.get(key);

        if (html === undefined) {
          try {
            const url = `${this.dataset.url}?section_id=cc-cart-recommendations&product_id=${productId}&limit=10&intent=related`;
            const response = await fetch(url);
            if (!response.ok) return;
            const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
            const inCart = new Set((this.dataset.exclude || '').split(','));
            html = [...doc.querySelectorAll('.cc-rec')]
              .filter((card) => !inCart.has(card.dataset.productId))
              .slice(0, 8)
              .map((card) => card.outerHTML)
              .join('');
            ccRecsCache.set(key, html);
          } catch (error) {
            return;
          }
        }

        if (!this.isConnected || !html) return;
        this.rail.innerHTML = html;
        this.hidden = false;
        this.updateArrows();
      }

      page(direction) {
        this.rail.scrollBy({ left: direction * this.rail.clientWidth * 0.8, behavior: 'smooth' });
      }

      updateArrows() {
        const max = this.rail.scrollWidth - this.rail.clientWidth;
        this.prev.disabled = this.rail.scrollLeft <= 2;
        this.next.disabled = this.rail.scrollLeft >= max - 2;
      }
    }
  );
}
